import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, CloseButton, Modal } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStreetView } from '@fortawesome/free-solid-svg-icons';

export default function StreetViewModal({ address, city, state, zip }) {
  const [show, setShow] = useState(false);
  const streetViewRef = useRef();

  useEffect(() => {
    if (show) {
      fetchStreetView();
    }
  }, [show]);

  const fetchStreetView = () => {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode(
      { address: `${address} ${city}, ${state} ${zip}` },
      (results, status) => {
        if (status === google.maps.StreetViewStatus.OK && results[0]) {
          const location = results[0].geometry.location;

          new google.maps.StreetViewPanorama(streetViewRef.current, {
            position: location,
            zoom: 1,
          });
        } else {
          setShow(false); // Close modal on error
        }
      }
    );
  };

  return (
    <React.Fragment>
      <Button variant="outline-primary" onClick={() => setShow(true)}>
        <FontAwesomeIcon icon={faStreetView} />
        Street View
      </Button>
      <Modal centered show={show} size="lg" onHide={() => setShow(false)}>
        <CloseButton className="p-3 ms-auto" onClick={() => setShow(false)} />
        <Modal.Body>
          <div ref={streetViewRef} style={{ height: '500px', width: '100%' }} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

StreetViewModal.propTypes = {
  address: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
};
